import { TokenContext } from '@cibo/core'

export const createYearTokenContext = (year?: number): TokenContext | undefined => {
  if (typeof year !== 'number' || Number.isNaN(year)) {
    return undefined
  }

  return {
    get: name => {
      if (name === 'year') {
        return year
      }

      return undefined
    },
  }
}